export default __webpack_public_path__ + "static/media/08.dd06f274.jpg";